import Swiper from 'swiper'

/**
 * All classes used in the component.
 * @enum {Object<string>}
 */
const CLASSES = {
  slider: 'dr-opportunities__slider'
}

/**
 * All breakpoints used in the component.
 * @enum {Object<number>}
 */
const BREAKPOINTS = {
  tablet: 768
}

/**
 * @module Opportunities
 */
class Opportunities {
  /**
   * @param {HTMLElement} element - The HTMLElement this module is constructed upon
   */
  constructor(element) {
    this.element_ = element
    this.sliderOptions = {
      loop: true,
      pagination: {
        el: '.swiper-pagination'
      }
    }
    this.swiper_ = {}
    this.init()
  }

  /**
   * Construct module.
   */
  init() {
    if (window.innerWidth < BREAKPOINTS.tablet) this.mountSwiper()
  }

  /**
   * Mount Swiper carousel.
   */
  mountSwiper() {
    this.swiper_ = new Swiper(`.${CLASSES.slider}`, this.sliderOptions)
  }
}

// Exports
export default Opportunities
